import { API_URL } from ".."

export const getAvatarUrlFromId = (userId: number | undefined) => {
  if (userId)
    return `${API_URL}/userAvatar/${userId}`
  return ""
}

export const getFileUrlFromId = (fileId: number | undefined) => {
  if (fileId)
    return `${API_URL}/Project/getFile?fileId=${fileId}`
  return ""
}